import { UserStatus } from '../enums/user-status.enum';

export const ACCOUNT_DETAILS_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.account.details.v2+json';

export class AccountDetails {
  public id: string;
  public email: string;
  public firstName: string;
  public lastName: string;
  public status: UserStatus;

  public get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  constructor(backEndAccount?: BackEndAccountDetails) {
    if (backEndAccount) {
      this.id = backEndAccount.id;
      this.email = backEndAccount.email;
      this.firstName = backEndAccount.first_name;
      this.lastName = backEndAccount.last_name;
      this.status = backEndAccount.status;
    }
  }

  public toBackEnd(): BackEndAccountDetails {
    return {
      id: this.id,
      email: this.email,
      first_name: this.firstName,
      last_name: this.lastName,
      status: this.status,
    };
  }

  public toBackEndPatch(): BackEndAccountDetailsPatch {
    return {
      id: this.id,
      first_name: this.firstName,
      last_name: this.lastName,
    };
  }
}

export interface BackEndAccountDetails {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  status: UserStatus;
}

export interface BackEndAccountDetailsPatch {
  id?: string;
  first_name?: string;
  last_name?: string;
}
